
(function entitiesModuleDefinition() {

    'use strict';

    angular.module('Entities', ['Config', 'Auth', 'RESTUrlBuilder', 'TrackableCollection'])
        .config([
            'configProvider', 'restUrlBuilderProvider',
            function(config, restUrlBuilderProvider) {
            }
        ]);

})();